import { Color, TypographyColor } from "../components/typography"
import { Svgs, svgOptions } from "../../types"
import { Text, types } from "react-bricks/frontend"
import Typography, { TypographyElement } from "../RedesignTypography"

import React from "react"
import SvgIcons from "../components/icon/svgIcons"
import classNames from "classnames"
import { cn } from "../../shared/utils/cn"

export interface IconTextShowMoreRedesignItemProps {
    index?: number
    headline: TypographyElement[]
    text: TypographyElement[]
    color?: TypographyColor
    icon: Svgs
}

const IconTextShowMoreRedesignItem: types.Brick<IconTextShowMoreRedesignItemProps> = ({ color, index, icon }) => {
    return (
        <li
            key={index}
            className={cn(
                "grid grid-cols-1 gap-5 xs:grid-cols-[52px_1fr] xs:gap-5.5 sm:w-1/2 sm:max-w-[411px] sm:grid-cols-[60px_1fr] sm:gap-5 md:max-w-[540px] lg:max-w-[560px] lg:grid-cols-[90px_1fr] lg:gap-[29px]",
                index! % 2 !== 0 ? "last:mb-0 sm:-my-10 sm:place-self-end md:pl-3.5 xl:mr-[120px]" : "md:pr-3.5"
            )}
        >
            <SvgIcons
                icon={icon}
                className={classNames("fill-[#f18d29] xs:justify-self-end", {
                    "w-12 sm:w-[51px] lg:w-22": icon === Svgs.balance,
                    "w-10.5 sm:w-11 lg:w-[57px]": icon === Svgs.bloodSugar,
                    "w-[51px] sm:w-[57px] lg:w-[87px]": icon === Svgs.bones,
                    "w-12 sm:w-15 lg:w-[87px]": icon === Svgs.cardio,
                    "w-[51px] lg:w-20": icon === Svgs.cells,
                    "w-[47px] sm:w-[51px] lg:w-20": icon === Svgs.concentration,
                    "w-9 sm:w-10.5 lg:w-[54px]": icon === Svgs.energy,
                    "w-[52px] sm:w-[56px] lg:w-[90px]": icon === Svgs.fertility,
                    "w-12 sm:w-[51px] lg:w-[82px]": icon === Svgs.hormone,
                    "w-10.5 sm:w-12 lg:w-[61px]": icon === Svgs.immune,
                    "w-12 sm:w-[58px] lg:w-[82px]": icon === Svgs.innerPeace,
                    "w-12 sm:w-[58px] lg:w-20": icon === Svgs.metabolism,
                    "w-[47px] sm:w-[53px] lg:w-[78px]": icon === Svgs.skin,
                    "w-[51px] lg:w-[70px]": icon === Svgs.thyroid,
                    "w-[47px] sm:w-[53px] lg:w-20": icon === Svgs.vitality,
                })}
            />
            <Color color={color}>
                <Text
                    propName="smallprint"
                    renderBlock={({ children }) => (
                        <p className="font-gibson text-xl font-semibold sm:text-3xl lg:text-5xl">{children}</p>
                    )}
                    placeholder="Lorem ipsum"
                />
                <Typography
                    propName="headline"
                    allowList={["S3", "S4", "link", "bold", "italic", "small", "sup"]}
                    className="[&_span]:mb-5! lg:[&_span]:mb-7!"
                />
                <Typography propName="text" size="P2" allowList={["link", "bold", "italic", "small", "sup"]} />
            </Color>
        </li>
    )
}

IconTextShowMoreRedesignItem.schema = {
    name: "IconTextShowMoreRedesignItem",
    label: "Icon Text Show More Redesign Item",
    hideFromAddMenu: true,
    sideEditProps: [
        {
            name: "icon",
            label: "Icon",
            type: types.SideEditPropType.Select,
            selectOptions: {
                options: svgOptions,
                display: types.OptionsDisplay.Select,
            },
        },
    ],
    getDefaultProps: (): IconTextShowMoreRedesignItemProps => ({
        icon: Svgs.vitality,
        headline: [
            {
                type: "paragraph",
                children: [
                    {
                        text: "Lorem ipsum",
                        S3: true,
                    },
                ],
            },
        ],
        text: [
            {
                type: "paragraph",
                children: [
                    {
                        text: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.",
                    },
                ],
            },
        ],
    }),
}

export default IconTextShowMoreRedesignItem
